// Exports
export default {
	"Container": "Container_+QkZ7",
	"UserBlock": "UserBlock_IZSZU",
	"UserAvatar": "UserAvatar_7nMIW",
	"UserInfo": "UserInfo_0GTxS",
	"UserName": "UserName_MMptc",
	"UserLogin": "UserLogin_RaIm1",
	"ChangeAvatarButton": "ChangeAvatarButton_u+umj"
};
